<template>
  <div>
    <v-card class="text-center">
      <v-dialog v-model="dialog" persistent max-width="600">
        <template v-slot:activator="{ on }">
          <v-container style="max-width: 600px; margin: 0 auto">
            <div class="mb-2 text-left">{{ $t("loginCreditBuyer") }}</div>
            <v-text-field
              class="mb-2"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="login"
              label="Login"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
            <div class="mb-2 text-left">{{ $t("valueCredit") }}</div>
            <v-text-field
              class="mb-2"
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="value"
              type="number"
              :prefix="$t('labelCurrency')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
            <v-btn
              @click="findPlayer"
              color="info"
              :loading="loadingFindingPlayer"
              class="mt-2"
              :disabled="emptyFields"
            >
              {{ $t("sellCredit") }}
            </v-btn>
          </v-container>
        </template>
        <v-card class="ma-0">
          <v-card-title primary-title class="px-4">
            <div class="headline mb-0">{{ $t("confirm") }}</div>

            <v-spacer></v-spacer>
            <v-btn icon @click="closeDialog"> <v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-alert :value="true" type="info" class="text-left mx-6 my-4">
            {{ $t("confirmYourPasswordDescription") }}
          </v-alert>

          <v-card-text class="pb-0 pt-4">
            <v-card-text class="pt-0">
              <p>Login: {{ login }}</p>
              <p>{{ $t("name") }}: {{ buyerName }}</p>
              <p>
                {{ $t("valueCredit") }}: {{ $t("labelCurrency") }} {{ value }}
              </p>
            </v-card-text>
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="password"
              type="password"
              :label="$t('password')"
              single-line
              hide-details
              solo-inverted
              clearable
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-btn
              tabindex="8"
              block
              type="submit"
              class="primary darken-1"
              @click="confirmAgentPassword"
              :disabled="!password || password.length < 6 || loading"
              :loading="loading"
              >{{ $t("confirm") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AgentSellCredit",
  data() {
    return {
      buyerName: "",
      password: "",
      login: "",
      value: "",
      dialog: false,
      loading: false,
      loadingFindingPlayer: false,
    };
  },
  computed: {
    emptyFields() {
      return !this.login || !this.value || this.value == 0;
    },
  },
  methods: {
    closeDialog() {
      this.dialog = false;
      this.password = "";
    },
    resetFields() {
      this.value = 0;
      this.login = "";
    },
    sellCredit() {
      const body = { login: this.login, value: this.value };
      this.$axios
        .post("/agent/credits/sellCredit", this.$formdata(body))
        .then((res) => {
          this.$store.commit("setNotification", {
            msg: res.data.messages,
            color: "success",
          });
          this.loading = false;
          this.resetFields();
          this.closeDialog();
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        });
    },
    confirmAgentPassword() {
      this.loading = true;

      const body = { password: this.password };
      this.$axios
        .post("/agent/profile/confirmPassword", this.$formdata(body))
        .then(() => {
          this.sellCredit();
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
          this.loading = false;
        });
    },
    findPlayer() {
      this.loadingFindingPlayer = true;

      const body = { login: this.login };
      this.$axios
        .post("/agent/credits/findPlayer", this.$formdata(body))
        .then((res) => {
          this.buyerName = res.data.dados.nome;
          this.dialog = true;
        })
        .catch((err) => {
          this.$store.commit("setNotification", {
            msg: err.response.data.messages.error,
            color: "warning",
          });
        })
        .finally((a) => {
          this.loadingFindingPlayer = false;
        });
    },
  },
};
</script>
